import script from "./EditPhotosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPhotosPage.vue?vue&type=script&setup=true&lang=js"

import "./EditPhotosPage.vue?vue&type=style&index=0&id=6a4660fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4660fb"]])

export default __exports__